(function () {

jQuery(document).ready(function($) {
    // Focus styles for menus when using keyboard navigation
    // Properly update the ARIA states on focus (keyboard) and mouse over events
    $('[role="menubar"]').on("focus.aria mouseenter.aria", '[aria-haspopup="true"]', function(ev) {
        $(ev.currentTarget).attr("aria-expanded", true);
    });
    // Properly update the ARIA states on blur (keyboard) and mouse out events
    $('[role="menubar"]').on("blur.aria mouseleave.aria", '[aria-haspopup="true"]', function(ev) {
        $(ev.currentTarget).attr("aria-expanded", false);
    });
    $(window).on("load", function() {});
    var resizeTimer;
    $(window).on("resize", function(e) {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {}, 50);
    });
    $(".rare-action-slides").slick({
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
});
document.addEventListener("DOMContentLoaded", ()=>{
    // Target all nav menu links with sub-menu items
    let navDropdownItems = document.querySelectorAll("#menu-main-menu .menu-item-has-children");
    // Loop through all nav menu links with sub-menu items
    for(let i = 0; i < navDropdownItems.length; i++){
        let navLink = navDropdownItems[i].getElementsByClassName("nav-link dropdown-toggle");
        for(let o = 0; o < navLink.length; o++)navLink[o].removeAttribute("data-bs-toggle");
        // On mouse hover add class "show" to nav-link and dropdown menu
        navDropdownItems[i].onmouseover = function() {
            for(let j = 0; j < navLink.length; j++)navLink[j].classList.add("show");
            let dropdownToggle = navDropdownItems[i].getElementsByClassName("dropdown-menu");
            for(let k = 0; k < dropdownToggle.length; k++)dropdownToggle[k].classList.add("show");
        };
        // On mouse leave remove class "show"
        navDropdownItems[i].onmouseout = function() {
            let navLink = navDropdownItems[i].getElementsByClassName("nav-link dropdown-toggle");
            for(let j = 0; j < navLink.length; j++)navLink[j].classList.remove("show");
            let dropdownToggle = navDropdownItems[i].getElementsByClassName("dropdown-menu");
            for(let k = 0; k < dropdownToggle.length; k++)dropdownToggle[k].classList.remove("show");
        };
    }
    ////////////////////////////////////////////////////////////////////////////////////////////////
    // let searchBox = document.getElementById("nav-search-box");
    // let searchForm = document.getElementById("nav-search-form");
    // let searchItem = document.getElementById("nav-search-box-item");
    // searchBox.onmouseover = () => {
    // 	searchForm.classList.add('show');
    // 	searchItem.classList.add('show');
    // }
    // searchBox.onmouseout = () => {
    // 	searchForm.classList.remove('show');
    // 	searchItem.classList.remove('show');
    // }
    /////////////////////////////////////////////////
    // Mobile: Show/Hide Nav Items children on Toggler Click
    ////////////////////////////////////////////////
    const navbarToggler = document.querySelector("#navbarToggler");
    const navbarNav = document.querySelector("#navbarNav");
    // Determine if screen is desktop or mobile then add class to navbarNav
    if (window.innerWidth < 992) navbarNav.classList.add("mobile-nav-screen");
    else navbarNav.classList.add("desktop-nav-screen");
    navbarToggler.addEventListener("click", (e)=>{
        if (!document.querySelector(".navbar-collapse").classList.contains("show")) navbarNav.classList.add("show");
        else navbarNav.classList.remove("show");
    });
    /////////////////////////////////////////////////
    // End - Mobile: Show/Hide Nav Items children on Toggler Click
    ////////////////////////////////////////////////
    /////////////////////////////////////////////////
    // Mobile: Show down icon on mobile nav items
    ////////////////////////////////////////////////
    if (document.querySelectorAll(".dropdown-toggle") && window.innerWidth < 992) {
        let dropdownToggle = document.querySelectorAll(".dropdown-toggle");
        let para = document.createElement("i");
        para.className = "bi bi-chevron-down mobile-nav-down";
        // let node = document.createTextNode("This is new.");
        // para.appendChild(node);
        dropdownToggle.forEach((element)=>{
            element.parentNode.innerHTML += `<i style="color:black;" class="bi bi-chevron-down mobile-nav-down"></i>`;
        });
        let drownArrow = document.querySelectorAll(".mobile-nav-down");
        drownArrow.forEach((element)=>{
            element.addEventListener("click", (e)=>{
                if (!element.previousElementSibling.classList.contains("show")) element.previousElementSibling.classList.add("show");
                else element.previousElementSibling.classList.remove("show");
            });
        });
    }
/////////////////////////////////////////////////
// End - Mobile: Show down icon on mobile nav items
////////////////////////////////////////////////
});

})();
//# sourceMappingURL=scripts.js.map
